import ApproveCourseModal from './ApproveCourseModal';
export default ApproveCourseModal;
